import React from 'react';
import {useForm} from 'react-hook-form';
import {useSearchParams} from 'react-router-dom';
import {t} from '@lingui/core/macro';

import {zoneAPI} from 'features/admin/api/zoneAPI';
import {countryAPI} from 'features/admin/api/countryAPI';
import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import Select from 'shared/ui/Select/Select';
import ListFiltersForm from 'shared/ui/Modal/ListFiltersForm/ListFiltersForm';
import {IFiltersFormComponentProps} from 'shared/ui/Modal/ListFiltersModal/ListFiltersModal';
import {getActiveOptions} from 'shared/lib/filterOptions';

interface ILocationsFiltersForm {
    published?: string,
    zone?: string,
    country?: string,
}

const LocationsFiltersForm: React.FC<IFiltersFormComponentProps> = ({onClose}) => {
    const [searchParams] = useSearchParams();

    const {handleSubmit, control, watch, setValue} = useForm<ILocationsFiltersForm>({
        defaultValues: {
            published: searchParams.get('published') ?? undefined,
            zone: searchParams.get('city.country.zone.id') ?? undefined,
            country: searchParams.get('city.country.id') ?? undefined,
        },
    });

    const zone = watch('zone');
    const {data: zones = []} = zoneAPI.useGetZonesQuery();
    const {data: countries = []} = countryAPI.useGetCountriesQuery(Number(zone), {skip: !zone});

    const zoneOptions = zones.map(item => ({label: item.name, value: String(item.id)}));
    const countryOptions = countries.map(item => ({label: item.name, value: String(item.id)}));

    const toFilters = (values: ILocationsFiltersForm) => ({
        published: values.published ?? undefined,
        'city.country.zone.id': values.zone ?? undefined,
        'city.country.id': values.zone ? values.country ?? undefined : undefined,
    });

    return (
        <ListFiltersForm handleSubmit={handleSubmit} toFilters={toFilters} onClose={onClose}>
            <FormGroupWithError label={t`Статус`}>
                <Select
                    control={control}
                    name="published"
                    data={getActiveOptions()}
                    cleanable={true}
                    searchable={false}
                />
            </FormGroupWithError>

            <FormGroupWithError label={t`Зона`}>
                <Select
                    control={control}
                    name="zone"
                    data={zoneOptions}
                    cleanable={true}
                    searchable={false}
                    onChange={() => setValue('country', undefined)}
                />
            </FormGroupWithError>

            <FormGroupWithError label={t`Страна`}>
                <Select
                    control={control}
                    name="country"
                    data={countryOptions}
                    cleanable={true}
                    searchable={countryOptions.length > 5}
                    disabled={!zone}
                />
            </FormGroupWithError>
        </ListFiltersForm>
    );
};

export default LocationsFiltersForm;
